import { TGetChangeHostItem } from './interfaces';

export const getChangeHostItem: TGetChangeHostItem = ({
  t,
  permissions,
  openChangeHostModal,
  selectedHostsIds,
}) => {
  return !permissions?.has('client_session_manage')
    ? null
    : {
        key: 'changeHost',
        text: t('host.ctx.session.changeHost'),
        iconName: 'LeftRightArrowsIcon',
        onClick: openChangeHostModal,
        disabled: ({ client_sessions: [activeSession], locked }) =>
          Boolean(!activeSession) ||
          locked ||
          !!(selectedHostsIds && selectedHostsIds.length > 1),
      };
};
